<template>
  <el-dialog
    :title="isEdit ? '编辑学历标签' : '添加学历标签'"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="标签类型" prop="tagType">
        <el-select v-model="form.tagType" placeholder="请选择标签类型" style="width: 300px;">
          <el-option :value="1" label="学校名称"></el-option>
          <el-option :value="2" label="学历类型"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签名称" prop="tagName">
        <el-input
          v-model="form.tagName"
          placeholder="请输入标签名称"
          maxlength="28"
          style="width: 300px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input
          v-model.trim="form.desc"
          style="width: 300px;"
          placeholder="请输入备注"
          type="textarea"
          maxlength="50"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { educationTagCreate, educationTagEdit } from '@/api/degree'
import to from 'await-to'

const validateTagName = (rule, value, callback) => {
  if (!value) return callback(new Error('请输入标签名称'))
  let len = 0
  for (let i = 0; i < value.length; i++) {
    len += value.charCodeAt(i) > 255 ? 2 : 1
  }
  if (len < 2 || len > 28) {
    return callback(new Error('标签名称限制2-28个字符，一个汉字代表2个字符'))
  }
  callback()
}

export default {
  name: 'DictDialog',
  data() {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      form: {
        educationTagId: null,
        tagType: '',
        tagName: '',
        desc: '',
      },
      rules: {
        tagType: [{ required: true, message: '请选择标签类型', trigger: 'change' }],
        tagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
          { validator: validateTagName, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    show(row) {
      this.visible = true
      if (row && row.educationTagId) {
        this.isEdit = true
        this.form = {
          educationTagId: row.educationTagId,
          tagType: row.tagType,
          tagName: row.tagName,
          desc: row.desc,
        }
      } else {
        this.isEdit = false
        this.form = {
          educationTagId: null,
          tagType: '',
          tagName: '',
          desc: '',
        }
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        const api = this.isEdit ? educationTagEdit : educationTagCreate
        const [, err] = await to(api(this.form))
        this.loading = false
        if (err) return this.$message.warning(err.msg)
        this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
        this.visible = false
        this.$emit('success')
      })
    },
  },
}
</script>
